import { useLanguage } from "@/contexts/LanguageContext";

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      <div className="container mx-auto px-4 pt-20">
        <div className="text-center max-w-5xl mx-auto animate-fade-in">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-foreground leading-[1.15] tracking-tight mb-8 font-sans">
            <div className="mb-3">
              <span className="font-light text-black">{t("Digital", "ديجيتال")}</span>{" "}
              <span className="font-bold text-black">{t("Bridge", "بريدج")}</span>
            </div>
            <div>
              <span className="font-medium">{t("Elevating", "نرتقي بـ")}</span>{" "}
              <span className="text-gradient-purple font-extrabold">{t("Businesses", "الأعمال")}</span>
            </div>
            <div>
              <span className="font-medium">{t("& Monetizing", "و نستثمر")}</span>{" "}
              <span className="text-gradient-purple font-extrabold">{t("Talents", "المواهب")}</span>
            </div>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
